export enum ApplicationStatus{
    PENDING = "PENDING",
    IN_REVIEW = "IN_REVIEW",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
    NEW_APPLICATION = "NEW_APPLICATION"
}